
<script>
    import { Router, Link, Route, navigate  } from "svelte-routing";
  import InserirUsuario from "../Telas/InsercaoDados/TelaInsereDadosUsuario.svelte";
  let url="";
  export let navegarPara='';
  function handleClick() {
    navigate(navegarPara);
    const button = document.getElementById('floating-button');
    button.classList.remove('pulse');
    setTimeout(() => {
      button.classList.add('pulse');
    }, 10); // Tempo pequeno para resetar a animação
  }
</script>
<div>
  
      
    
  
  <button class=' pulse' id="floating-button" on:click={handleClick}>
    <i class="fas fa-plus"></i>
  </button>

</div>

<style>
  div {
    position: fixed;
    bottom: 20px;
    right: 20px;
    margin-bottom: 50px;
  }
  
  button {
    width: 50px;
  
    border-radius: 50%;
    background-color: #fca001;
    border: none;
    transition: transform 0.1s ease-in-out; /* Adicionando a transição */
  }

  i {
    color: white;
    font-size: 24px;
    line-height: 50px;
    text-align: center;
    border: none;
  }

  /* Adicionando regra de estilo para animar o botão quando clicado */
  .pulse {
    animation: pulse 0.4s ease; /* Animação de pulso */
  }

  @keyframes pulse {
    0% {
      transform: scale(1); /* Estado inicial */
    }
    50% {
      transform: scale(1.1); /* Estado intermediário */
    }
    100% {
      transform: scale(1); /* Estado final */
    }
  }
</style>


